import { getStore } from '@/utils/util'

export default {
  methods: {
    /**
     * 带服务参数的路由跳转
     * @param {Object|string} location - 路由位置对象或路径
     * @returns {Promise} 路由跳转的 Promise
     */
    routerPushWithService(location) {
      const serviceParam = getStore('serviceParam')
      const serviceValue = getStore('serviceValue')
      const serviceCode = getStore('serviceCode')
      const serviceCategoryL2Code = getStore('serviceCategoryL2Code')
      const specifySerCategoryL2Code = getStore('specifySerCategoryL2Code')
      const specialService = getStore('specialService')
      const storeCode = getStore('storeCode')
      const refValue = getStore('ref')

      // 转换路由配置对象
      const routeConfig = typeof location === 'string'
        ? { path: location }
        : { ...location }

      // 添加查询参数
      if (serviceParam && serviceValue) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          [serviceParam]: serviceValue
        }
      }

      if (serviceCode) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          serviceCode
        }
      }

      if (serviceCategoryL2Code) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          serviceCategoryL2Code
        }
      }

      if (specifySerCategoryL2Code) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          specifySerCategoryL2Code
        }
      }

      if (specialService) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          specialService
        }
      }

      if (storeCode) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          storeCode
        }
      }

      if (refValue) {
        routeConfig.query = {
          ...(routeConfig.query || {}),
          ref: refValue
        }
      }

      // 确保使用完整的路由配置
      const fullConfig = {
        path: routeConfig.path,
        query: routeConfig.query || {},
        params: routeConfig.params || {}
      }

      console.log('Router config:', fullConfig)

      // 返回 Promise 以便处理导航结果
      return this.$router.push(fullConfig).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation failed:', err)
          throw err
        }
      })
    }
  }
}